import React from "react";
import { useSelector } from "react-redux";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import RawLeads from "../../components/lead-management/raw-leads/RawLeads";

const RawLead = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Raw Lead Management System">
      <RawLeads userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default RawLead;
